import type { TurboFrameLoadEvent } from "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import { CoreWebStimulusControllers } from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/Generated/CoreWebStimulusControllers";
import { CoreWebAccountStimulusControllers } from "../../../Libraries/CoreWeb/CoreWeb.Account/Features/Shared/Generated/CoreWebAccountStimulusControllers";
import { StimulusControllers } from "./Generated/StimulusControllers";
import { logError } from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/logging";

import "./site.css";


import BodyController from "./BodyController";
import TurboFrameController from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/TagHelpers/TurboFrame/TurboFrameController";
import OnboardingController from "./TagHelpers/Onboarding/OnboardingController";
import ViewOrEditFormController from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/TagHelpers/ViewOrEditForm/ViewOrEditFormController";
import HintController from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/TagHelpers/Hint/HintController";

import ScrapersCreateController from "../Scrapers/Create/CreateController";
import ScrapersDetailController from "../Scrapers/Detail/DetailController";
import ScrapersDetailActionsController from "../Scrapers/Detail/Actions/ActionsController";
import ScrapersDetailWebPageController from "../Scrapers/Detail/WebPage/WebPageController";
import ScrapersDetailWebPageOverviewController from "../Scrapers/Detail/WebPage/WebPageOverviewController";
import ScrapersDetailWebPageDisabledWarningController from "../Scrapers/Detail/WebPage/WebPageDisabledWarningController";
import ScrapersDetailWebPageScrapedResultsController from "../Scrapers/Detail/WebPage/WebPageScrapedResultsController";
import ScrapersScrapedResultsController from "../Scrapers/ScrapedResults/ScrapedResultsController";
import ScrapersScrapedResultsWebPagesController from "../Scrapers/Shared/ScrapedResultsWebPages/ScrapedResultsWebPagesController";
import WatchdogsDetailController from "../Watchdogs/Detail/DetailController";
import WatchdogsDetailOverviewController from "../Watchdogs/Detail/Overview/OverviewController";

import AccountLoginLinkLoginController from "../../../Libraries/CoreWeb/CoreWeb.Account/Features/LoginLink/Login/LoginController";
import AccountLoginLinkLoginLinkSentController from "../../../Libraries/CoreWeb/CoreWeb.Account/Features/LoginLink/LoginLinkSent/LoginLinkSentController";


const application = Application.start();
application.register(StimulusControllers.body, BodyController);
application.register(CoreWebStimulusControllers.turboFrame, TurboFrameController);
application.register(StimulusControllers.onboarding, OnboardingController);
application.register(CoreWebStimulusControllers.viewOrEditForm, ViewOrEditFormController);
application.register(CoreWebStimulusControllers.hint, HintController);

application.register(StimulusControllers.scrapersCreate, ScrapersCreateController);
application.register(StimulusControllers.scrapersDetail, ScrapersDetailController);
application.register(StimulusControllers.scrapersDetailActions, ScrapersDetailActionsController);
application.register(StimulusControllers.scrapersDetailWebPage, ScrapersDetailWebPageController);
application.register(StimulusControllers.scrapersDetailWebPageOverview, ScrapersDetailWebPageOverviewController);
application.register(StimulusControllers.scrapersDetailWebPageDisabledWarning, ScrapersDetailWebPageDisabledWarningController);
application.register(StimulusControllers.scrapersDetailWebPageScrapedResults, ScrapersDetailWebPageScrapedResultsController);
application.register(StimulusControllers.scrapersScrapedResults, ScrapersScrapedResultsController);
application.register(StimulusControllers.scrapersScrapedResultsWebPages, ScrapersScrapedResultsWebPagesController);
application.register(StimulusControllers.watchdogDetail, WatchdogsDetailController);
application.register(StimulusControllers.watchdogDetailOverview, WatchdogsDetailOverviewController);

application.register(CoreWebAccountStimulusControllers.accountLoginLinkLogin, AccountLoginLinkLoginController);
application.register(CoreWebAccountStimulusControllers.accountLoginLinkLoginLinkSent, AccountLoginLinkLoginLinkSentController);


attachValidationOnTurboLoad();
scrollToFragmentIdentifierOnTurboLoad();
handleErrorsGlobally();

console.log("App reloaded");


function attachValidationOnTurboLoad() {
    document.addEventListener("turbo:load", () => {
        $.validator.unobtrusive.parse(document);
    });

    document.addEventListener("turbo:frame-load", (event: TurboFrameLoadEvent) => {
        const target = event.target as Element;
        $.validator.unobtrusive.parse(target);
    });
}

function scrollToFragmentIdentifierOnTurboLoad() {
    document.addEventListener("turbo:load", () => {
        scrollFragmentIdentifierElementIntoView();
    });

    document.addEventListener("turbo:frame-load", (event: TurboFrameLoadEvent) => {
        scrollFragmentIdentifierElementIntoView();
    });

    function scrollFragmentIdentifierElementIntoView() {
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);
            if (el) {
                el.scrollIntoView();
            }
        }
    }
}

function handleErrorsGlobally() {
    
    window.onerror = async (message, source, lineno, colno, error) => {
        await logError(error ?? message, {source, lineno, colno});
    };

    window.addEventListener("unhandledrejection", async (event: PromiseRejectionEvent) => {
        await logError(event.reason);
    });

    application.handleError = async (error: Error, message: string, detail: object) => {
        console.error(error, message, detail);

        // @ts-ignore
        let stimulusIdentifier = detail?.identifier;
        // @ts-ignore
        let elementId = detail?.element?.id;

        await logError(error, {stimulusIdentifier, elementId});
    }
}